module.exports = __webpack_public_path__ + "static/media/game(6).1e651860.PNG";